import { withScope } from '@bingads-webui-react/scope-service';
import { stepStateMachine } from '@bingads-webui-campaign-react/step-wizard-machine';
import { STEP_PATHS } from '../../common/constants';
import { StepCampaignSettingsShell } from './step-campaign-settings';
import { initialCampaignCriterionsViewModel } from '../../model/campaign-criterions';
import { initialBrandExclusionsViewModel, initialCampaignViewModel } from '../../model/campaign';
import { getErrorsPlaceholders } from '../../model/campaign-bulk';
import { loadData, saveData, patchStepsData, clearErrors, needsLoading, isValid, isDirty, needsSaving, hasIncomingSystemError } from './step-campaign-settings-impl';

export const stepCampaignSettingsWizardConfig = {
  id: STEP_PATHS.CAMPAIGN_SETTINGS,
  title: _TL_('Campaign settings'),
  StepMachine: stepStateMachine,
  StepMachineOptions: (stepInfo, initialStepsData) => ({
    machineId: STEP_PATHS.CAMPAIGN_SETTINGS,
    initialContext: {
      id: stepInfo.id,
      stepsData: initialStepsData,
      stepInfo,
      data: {
        campaign: initialCampaignViewModel,
        campaignCriterions: initialCampaignCriterionsViewModel,
        brandExclusions: initialBrandExclusionsViewModel,
        ...getErrorsPlaceholders(),
      },
      invalidSaveAttempt: 0,
    },
    actions: {
      patchStepsData,
      clearErrors,
    },
    guards: {
      needsLoading,
      isValid,
      isDirty,
      needsSaving,
      hasIncomingSystemError,
    },
  }),
  StepComponent: withScope(StepCampaignSettingsShell),
  stepRepositoryConfig: {
    saveData,
    loadData,
  },
};
